import Reveal from '@/components/base/Reveal';
import { warningPoints } from '@/mocks/home';

export default function WarningSection() {
  return (
    <section id="warning" className="relative w-full bg-foreground-950 topographic-lines py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-10 lg:gap-16 items-start">
          <Reveal>
            <span className="text-xs md:text-sm tracking-[0.2em] text-primary-400">CHECKLIST · 警示要点</span>
            <h3 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug">
              出发之前，
              <br className="hidden md:block" />
              请先记住这五点
            </h3>
            <p className="mt-4 text-sm leading-7 text-foreground-400 max-w-md">
              这些要点来自多位亲历者的口述反复提到的地方，简单、直接，也最容易被忽略。
            </p>
          </Reveal>

          <Reveal delay={100}>
            <ul className="flex flex-col">
              {warningPoints.map((point, index) => (
                <li
                  key={point.text}
                  className={`flex items-start gap-4 py-5 ${
                    index !== warningPoints.length - 1 ? 'border-b border-foreground-800' : ''
                  }`}
                >
                  <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-md bg-primary-500/15 text-primary-400">
                    <i className={`${point.icon} text-lg`}></i>
                  </span>
                  <p className="pt-1.5 text-sm md:text-[15px] leading-7 text-background-100">{point.text}</p>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}